module.exports = __webpack_public_path__ + "assets/4e7821c9bf9ab1de377d8f73b2daf968.png";